(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["emporio-beyblade-chicche"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('emporio-beyblade')){
  customElements.define('emporio-beyblade',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.status=this.querySelector('[role="status"]');
      this.querySelector('button').addEventListener('click',()=>this.play(true),{signal:this.controller.signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape')this.stop();},{signal:this.controller.signal});
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stop();},{signal:this.controller.signal});
      let seen=false;
      try{seen=sessionStorage.getItem('emporio-beyblade-v1')==='seen';}catch(error){seen=false;}
      if(!seen&&!this.motion.matches&&'IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.play(false);}
        },{threshold:.7});
        this.observer.observe(this);
      }
    }
    play(announce){
      this.stop();
      try{sessionStorage.setItem('emporio-beyblade-v1','seen');}catch(error){}
      if(announce)this.status.textContent=this.dataset.message;
      if(!this.motion.matches){void this.offsetWidth;this.classList.add('is-playing');}
      this.timer=window.setTimeout(()=>this.stop(),2300);
    }
    stop(){window.clearTimeout(this.timer);this.classList.remove('is-playing');if(this.status)this.status.textContent='';}
    disconnectedCallback(){this.stop();this.observer?.disconnect();this.controller?.abort();this.controller=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-category-gags"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (customElements.get('emporio-gags')) return;
  const NS = 'http://www.w3.org/2000/svg';
  const DURATION = 3400;
  const GRID = [
    [35,0,247,333],[350,0,280,333],[644,0,296,333],[1000,0,220,333],
    [15,333,307,308],[368,333,234,308],[638,333,302,308],[981,330,236,311],
    [24,641,292,287],[351,640,257,288],[641,640,293,288],[957,635,285,293],
    [11,945,308,265],[353,928,259,285],[640,928,295,285],[951,928,286,285]
  ];
  const normal = value => {
    try { return decodeURIComponent(value).normalize('NFC').toLowerCase().replace(/\/+$/, '') || '/'; }
    catch (_) { return value.toLowerCase().replace(/\/+$/, '') || '/'; }
  };
  function resolveRoute(routes, href) {
    const url = new URL(href, location.origin);
    const path = normal(url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/');
    const matches = routes.filter(route => normal(route.path) === path);
    const themes = url.searchParams.getAll('filter.p.m.custom.tema').map(normal);
    return matches.find(route => route.theme && themes.includes(normal(route.theme))) || matches.find(route => !route.theme) || null;
  }
  class EmporioGags extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      try { this.config = JSON.parse(this.querySelector('[data-eg-data]').textContent); }
      catch (_) { return; }
      this.dock = this.querySelector('.eg-dock');
      this.scene = this.querySelector('.eg-scene');
      this.canvas = this.querySelector('.eg-canvas');
      this.bubble = this.querySelector('.eg-bubble');
      this.replay = this.querySelector('.eg-replay');
      this.mute = this.querySelector('.eg-mute');
      this.status = this.querySelector('.eg-status');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.small = matchMedia('(max-width: 700px)');
      this.animations = [];
      this.sequence = 0;
      this.lab = this.dataset.lab === 'true' && new URL(location.href).searchParams.has('emporio_gags');
      this.muted = this.read('muted') === '1';
      this.querySelector('.eg-touch').addEventListener('click', () => this.play(this.current, true), {signal});
      this.querySelector('.eg-close').addEventListener('click', () => this.stop(), {signal});
      this.replay.addEventListener('click', () => this.play(this.current), {signal});
      this.mute.addEventListener('click', () => {
        this.muted = true;
        this.write('muted','1');
        this.stop();
        this.dock.hidden = true;
      }, {signal});
      document.addEventListener('keydown', event => { if(event.key === 'Escape') this.stop(); }, {signal});
      document.addEventListener('visibilitychange', () => { if(document.hidden) this.stop(); }, {signal});
      document.addEventListener('focusin', event => {
        if(!this.contains(event.target) && event.target.matches('input,textarea,select')) this.stop();
      }, {signal});
      window.addEventListener('pagehide', () => this.stop(), {signal});
      window.addEventListener('pageshow', event => this.route(event.persisted), {signal});
      window.addEventListener('popstate', () => this.route(), {signal});
      window.addEventListener('emporio:legacy-chicca', () => {
        this.stop(false, false);
        this.replay.hidden = true;
        this.mute.hidden = true;
      }, {signal});
      window.addEventListener('emporio:cart-added', () => this.stop(true, false), {signal});
      this.motion.addEventListener('change', () => this.stop(), {signal});
      this.small.addEventListener('change', () => { this.stop(); this.route(true); }, {signal});
      document.addEventListener('shopify:section:load', () => this.route(true), {signal});
      this.observer = new MutationObserver(records => {
        if(records.every(record => this.contains(record.target))) return;
        clearTimeout(this.observerTimer);
        this.observerTimer = setTimeout(() => {
          if(this.blocked()) {
            if(this.dataset.state !== 'idle' && this.current) this.pendingEntry = this.current.id;
            this.stop(); this.dock.hidden = true;
          }
          else {
            this.route();
            if(this.current && !this.muted && !(this.dataset.mobile === 'false' && this.small.matches)) this.dock.hidden = false;
            if(this.pendingEntry && this.current?.id === this.pendingEntry && !this.lab) this.enter(this.current);
          }
        },120);
      });
      this.observer.observe(document.documentElement, {subtree:true,childList:true,attributes:true,attributeFilter:['class','open','aria-hidden']});
      this.setupLab(signal);
      this.route(true);
    }
    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.observer?.disconnect();
      clearTimeout(this.observerTimer);
      clearTimeout(this.entryTimer);
      this.abort = null;
    }
    read(key) { try { return sessionStorage.getItem('emporio-gags-v2:'+key); } catch (_) { return null; } }
    write(key,value) { try { sessionStorage.setItem('emporio-gags-v2:'+key,value); } catch (_) {} }
    blocked() {
      if(document.hidden || document.documentElement.classList.contains('m6pn-open')) return true;
      return Array.from(document.querySelectorAll('dialog[open],.fancybox__container,.m6pn.toggle,.m6pn[aria-hidden="false"],.popup-a[aria-hidden="false"]')).some(node => {
        const r = node.getBoundingClientRect(), style = getComputedStyle(node);
        return r.width > 20 && r.height > 20 && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
      });
    }
    route(force = false) {
      const route = resolveRoute(this.config.routes, location.href);
      if(route?.path === '/' && document.querySelector('.emporio-home__seasonal-wrap.is-halloween')) {
        this.stop();
        this.current = null;
        this.routeId = '';
        this.dock.hidden = true;
        return;
      }
      if(!force && route?.id === this.routeId) return;
      this.stop();
      this.routeId = route?.id || '';
      this.current = route;
      this.dataset.route = this.routeId;
      if(!route || this.muted || (this.dataset.mobile === 'false' && this.small.matches)) {
        this.dock.hidden = true;
        return;
      }
      this.dock.hidden = this.blocked();
      this.replay.hidden = this.dataset.replay === 'false';
      this.mute.hidden = this.replay.hidden;
      if(this.lab) {
        this.querySelector('[data-eg-select]').value = route.id;
        return;
      }
      this.enter(route);
    }
    enter(route) {
      if(!this.isConnected || this.current?.id !== route.id) return;
      if(this.pendingEntry === route.id && this.entryTimer) return;
      this.pendingEntry = '';
      const url = new URL(location.href);
      const isUtility = url.searchParams.has('sort_by') || url.searchParams.has('page') || Array.from(url.searchParams.keys()).some(k=>k.startsWith('filter.v.') || k.startsWith('filter.p.v.'));
      if(isUtility && this.read('last') === route.id) return;
      this.pendingEntry = route.id;
      clearTimeout(this.entryTimer);
      this.entryTimer = setTimeout(() => this.waitForEntry(route), 900);
    }
    waitForEntry(route) {
      this.entryTimer = null;
      if(!this.isConnected || this.current?.id !== route.id || this.muted) return;
      if(document.readyState === 'loading' || this.blocked()) {
        this.entryTimer = setTimeout(() => this.waitForEntry(route), 350);
        return;
      }
      this.pendingEntry = '';
      this.write('last', route.id);
      this.play(route);
    }
    async atlasReady() {
      if(!this.atlasPromise) {
        this.atlasPromise = new Promise(resolve => {
          const image = new Image();
          image.decoding = 'async';
          image.onload = () => resolve(true);
          image.onerror = () => resolve(false);
          image.src = this.dataset.atlas;
        });
      }
      return this.atlasPromise;
    }
    stop(showReplay = true, stopLegacy = true) {
      this.sequence++;
      clearTimeout(this.endTimer);
      clearTimeout(this.entryTimer);
      this.entryTimer = null;
      for(const animation of this.animations || []) animation.cancel();
      this.animations = [];
      if(this.scene) this.scene.hidden = true;
      this.dataset.state = 'idle';
      if(this.replay) {
        this.replay.hidden = !showReplay || this.dataset.replay === 'false' || !this.current || this.muted;
        this.mute.hidden = this.replay.hidden;
      }
      const legacy = document.querySelector('emporio-chicche');
      if(stopLegacy && !legacy?.dataset.state?.startsWith('arm')) legacy?.stop?.();
    }
    async salute(route) {
      this.stop();
      const sequence = this.sequence;
      if(!await this.atlasReady() || sequence !== this.sequence || this.blocked()) return;
      this.canvas.replaceChildren();
      const dragon = this.actor(8,195,64,144,145);
      this.bubble.textContent = this.config.ui.welcome;
      this.scene.hidden = false;
      this.dock.hidden = false;
      this.replay.hidden = true;
      this.mute.hidden = true;
      this.dataset.state = 'salute';
      if(!this.motion.matches) this.animate(dragon.motion,[{transform:'rotate(-5deg)'},{transform:'rotate(4deg)'},{transform:'rotate(0)'}],{duration:700});
      this.endTimer = setTimeout(()=>this.stop(),1500);
    }
    async play(route, tapped = false) {
      if(!route || this.muted) return;
      this.stop();
      this.pauseRequested = null;
      this.current = route;
      if(this.blocked()) return;
      if(!tapped && (route.mode === 'legacy_hot' || route.mode === 'legacy_battle')) {
        const legacy = document.querySelector('emporio-chicche');
        const kind = route.mode === 'legacy_hot' ? 'hot' : 'battle';
        if(legacy && !this.motion.matches) {
          this.dock.hidden = false;
          const played = await legacy.start(kind);
          if(played) {
            this.write(route.id,'1');
            this.dataset.state = kind;
            this.canvas.replaceChildren();
            this.scene.hidden = false;
            this.endTimer = setTimeout(()=>this.stop(),kind === 'hot' ? 4350 : 2550);
            if(this.pauseRequested !== null) this.seek(this.pauseRequested);
            return;
          }
        }
      }
      const sequence = this.sequence;
      if(!await this.atlasReady() || sequence !== this.sequence || !this.isConnected || this.blocked()) return;
      this.canvas.replaceChildren();
      this.replay.hidden = true;
      this.mute.hidden = true;
      this.scene.hidden = false;
      this.dock.hidden = false;
      this.dataset.state = tapped ? 'reaction' : 'playing';
      this.dataset.scene = route.id;
      this.bubble.textContent = this.config.lines[route.id];
      this.build(route, tapped);
      if(this.motion.matches) {
        this.seek(.74);
        this.endTimer = setTimeout(()=>this.stop(),6500);
      } else {
        this.animate(this.scene,[
          {opacity:0,transform:'translateY(20px) scale(.96)',offset:0},
          {opacity:1,transform:'translateY(0) scale(1)',offset:.09},
          {opacity:1,transform:'translateY(0) scale(1)',offset:.91},
          {opacity:0,transform:'translateY(12px) scale(.98)',offset:1}
        ],{duration:tapped ? DURATION : 6500},true);
      }
      this.write(route.id,'1');
      if(tapped) this.status.textContent = this.config.lines[route.id];
      if(this.pauseRequested !== null && this.lab) this.seek(this.pauseRequested);
    }
    animate(node, frames, options = {}, master = false) {
      if(this.dryRun) return null;
      const animation = node.animate(frames,Object.assign({duration:DURATION,fill:'both',easing:'ease-in-out'},options));
      this.animations.push(animation);
      if(master) animation.onfinish = () => this.stop();
      return animation;
    }
    seek(progress) {
      this.pauseRequested = progress;
      clearTimeout(this.endTimer);
      if(this.dataset.state === 'hot' || this.dataset.state === 'battle') document.querySelector('emporio-chicche')?.seek?.(progress);
      for(const animation of this.animations) {
        animation.pause();
        const timing = animation.effect.getTiming();
        animation.currentTime = Math.min(Number(timing.duration) || DURATION,DURATION*progress);
        if(typeof animation.commitStyles === 'function') {
          animation.commitStyles();
          animation.cancel();
        }
      }
    }
    svg(tag, attrs = {}, parent = this.canvas) {
      const el=document.createElementNS(NS,tag);
      for(const [key,value] of Object.entries(attrs)) el.setAttribute(key,String(value));
      parent.append(el);
      return el;
    }
    actor(pose,x,y,w,h) {
      const root=this.svg('g',{transform:'translate('+x+' '+y+')'});
      const motion=this.svg('g',{'class':'eg-actor'},root);
      motion.style.transformBox='view-box';
      motion.style.transformOrigin=(w/2)+'px '+h+'px';
      const actor={root,motion,x,y,w,h,layers:[]};
      this.pose(actor,pose,0);
      return actor;
    }
    pose(actor,index,at=.45) {
      const rect=GRID[index];
      if(!rect) throw new Error('Unknown mascot pose '+index);
      const scale=Math.min(actor.w/rect[2],actor.h/rect[3]);
      const clipId='eg-pose-'+(++this.clipId || (this.clipId=1));
      const clip=this.svg('clipPath',{id:clipId,clipPathUnits:'userSpaceOnUse'},actor.motion);
      this.svg('rect',{x:0,y:0,width:actor.w,height:actor.h},clip);
      const frame=this.svg('g',{'clip-path':'url(#'+clipId+')'},actor.motion);
      this.svg('image',{href:this.dataset.atlas,x:(actor.w-rect[2]*scale)/2-rect[0]*scale,y:actor.h-rect[3]*scale-rect[1]*scale,width:1254*scale,height:1254*scale},frame);
      if(actor.layers.length) {
        const previous=actor.layers[actor.layers.length-1];
        this.visible(previous,0,at);
        this.visible(frame,at,1);
      }
      actor.layers.push(frame);
      return frame;
    }
    prop(name,x,y,w=64,h=w,color='#c88e47') {
      if(!this.querySelector('#eg-'+name)) throw new Error('Missing scene object '+name);
      const root=this.svg('g',{transform:'translate('+x+' '+y+')'});
      const el=this.svg('g',{'class':'eg-prop',color:color},root);
      this.svg('use',{href:'#eg-'+name,x:0,y:0,width:w,height:h},el);
      return el;
    }
    word(text,x,y,size=14,parent=this.canvas) {
      const el=this.svg('text',{x:x,y:y,'font-size':size,'font-family':'system-ui,sans-serif','font-weight':800,'text-anchor':'middle',fill:'#422d26'},parent);
      el.textContent=text;
      return el;
    }
    path(d,stroke='#c59956',width=3,fill='none') { return this.svg('path',{d:d,stroke:stroke,'stroke-width':width,fill:fill,'stroke-linecap':'round'}); }
    visible(el,start=0,end=1) {
      const frames=[{opacity:start===0?1:0,offset:0}];
      if(start>0) frames.push({opacity:0,offset:Math.max(0,start-.001)},{opacity:1,offset:start});
      if(end<1) frames.push({opacity:1,offset:end},{opacity:0,offset:Math.min(1,end+.001)});
      frames.push({opacity:end===1?1:0,offset:1});
      this.animate(el,frames,{easing:'linear'});
    }
    travel(el,points) {
      this.animate(el,points.map(p=>({offset:p[0],transform:'translate('+p[1]+'px,'+p[2]+'px) rotate('+(p[3]||0)+'deg) scale('+(p[4]===undefined?1:p[4])+')'})));
    }
    pop(el,at=.35) { this.animate(el,[{opacity:0,transform:'scale(.2)',offset:0},{opacity:0,transform:'scale(.2)',offset:Math.max(0,at-.01)},{opacity:1,transform:'scale(1.15)',offset:at+.05},{opacity:1,transform:'scale(1)',offset:Math.min(.99,at+.14)},{opacity:1,transform:'scale(1)',offset:1}]); }
    wobble(el,at=.45,size=8) { this.travel(el,[[0,0,0],[at,0,0],[at+.08,0,0,-size],[at+.16,0,0,size],[Math.min(.98,at+.24),0,0],[1,0,0]]); }
    burst(x,y,color='#edb957') {
      for(let i=0;i<7;i++) {
        const a=i*Math.PI*2/7;
        const dot=this.svg('circle',{cx:x,cy:y,r:i%2?3:2,fill:color});
        this.animate(dot,[{opacity:0,transform:'translate(0,0)',offset:0},{opacity:0,transform:'translate(0,0)',offset:.38},{opacity:1,transform:'translate(0,0)',offset:.4},{opacity:0,transform:'translate('+(Math.cos(a)*45)+'px,'+(Math.sin(a)*36)+'px)',offset:.7},{opacity:0,offset:1}]);
      }
    }
    build(c,tap=false) {
      const mode=c.mode, p=c.props, ui=this.config.ui;
      const s=this.actor(c.poses[0],25,40,128,164);
      const d=this.actor(8+c.poses[1],206,80,139,127);
      const center=(name=p[0],w=70,y=129)=>this.prop(name,148,y,w,w);
      const right=(name=p[1]||p[0],w=42)=>this.prop(name,252,144,w,w);
      const reaction=(pose=3,at=.49)=>this.pose(s,pose,at);
      const grin=(pose=5,at=.55)=>this.pose(d,8+pose,at);
      const object=center;
      const finish=()=>{if(tap){this.wobble(d.motion,.30,6);this.burst(249,115);} };
      switch(mode) {
        case 'door': case 'bookdoor': {
          const door=this.prop('door',30,35,124,171);
          this.animate(door,[{transform:'scaleX(1)',offset:0},{transform:'scaleX(.12)',offset:.4},{transform:'scaleX(.12)',offset:1}]);
          this.travel(s.motion,[[0,-70,0],[.45,10,0],[1,10,0]]);
          const bag=right('bag',56);
          this.travel(bag,[[0,-15,0],[.5,55,10],[1,55,10]]);
          if(mode==='bookdoor') {const b=center('book',90);this.wobble(b);center('hat',40,100);}
          if(tap){const die=center('d20',27,150);this.travel(die,[[0,50,-15],[.4,0,31,200],[.8,25,25,290],[1,25,25,290]]);}
          break;
        }
        case 'stash': case 'treasure': {
          const chest=center('chest',94,113);
          this.travel(chest,[[0,69,0],[.2,69,0],[.6,0,0],[1,0,0]]);
          grin(tap?5:1);
          this.wobble(d.motion,.32,7);
          const key=this.prop(mode==='treasure'?'trumpet':'key',179,106,37,37);this.pop(key,.52);
          if(tap) this.burst(196,138);
          break;
        }
        case 'statue': case 'pose': case 'shadow': {
          const base=this.prop('plinth',42,177,94,35);
          if(mode==='shadow') {
            const shadow=this.actor(7,3,8,183,206);
            shadow.root.style.opacity='.13';shadow.root.style.filter='brightness(0)';
            this.canvas.insertBefore(shadow.root,s.root);
            this.travel(s.motion,[[0,0,0,0,.55],[.5,0,0,0,.55],[1,0,0,0,.55]]);
          } else {
            this.wobble(s.motion,.2,mode==='pose'?15:5);
            reaction(tap?7:(mode==='pose'?2:0),.52);
          }
          if(p.includes('rock')) {const rock=center('rock',42,165);this.pop(rock,.3);}
          this.wobble(base,.61,3);break;
        }
        case 'soccer': {
          const ball=this.prop('ball',0,178,28,28);
          const goal=this.prop('goal',286,125,62,78);
          this.travel(ball,[[0,-40,0,0],[.24,47,0,110],[.57,97,0,170],[.82,294,0,700],[1,tap?260:294,tap?-24:0,800]]);
          const binoculars=this.prop('binoculars',87,59,38,31);this.pop(binoculars,.35);
          this.wobble(goal,.84,4);break;
        }
        case 'cape': {
          const cape=this.prop('cape',0,77,84,126);
          this.travel(s.motion,[[0,-30,0],[.35,12,0],[.5,-8,0,-10],[.7,0,0],[1,0,0]]);
          this.travel(cape,[[0,-40,0],[.35,12,0],[.6,0,0],[1,0,0]]);
          reaction(tap?4:2);grin(7);
          if(p.includes('signal')) {const signal=center('signal',100,34);this.visible(signal,.05,.6);}
          break;
        }
        case 'water': {
          const arc=this.path('M48 155Q112 20 221 112Q255 151 223 170','#67b5ca',11);
          this.animate(arc,[{opacity:0,strokeDasharray:'0 400',offset:0},{opacity:1,strokeDasharray:'400 400',offset:.4},{opacity:0,offset:.65},{opacity:0,offset:1}]);
          const sword=center('sword',75,103);this.wobble(sword,.2,60);
          const drop=this.prop('drop',97,82,15,20,'#71b9cd');this.pop(drop,.42);
          reaction(2,.62);
          if(tap){const umbrella=right('umbrella',79);this.pop(umbrella,.4);}
          break;
        }
        case 'notebook': {
          const cover=this.prop('notebook',139,69,100,126);
          const open=this.prop('book',131,77,113,117);
          this.visible(open,.48,1);
          this.animate(cover,[{transform:'scaleX(1)',offset:0},{transform:'scaleX(1)',offset:.27},{transform:'scaleX(.01)',offset:.49},{transform:'scaleX(.01)',offset:1}]);
          this.visible(cover,0,.48);
          const words=this.word(ui.wishlist,187,128,11);this.visible(words,.51,1);
          reaction(7,.60);
          const apple=this.prop('apple',212,170,32,32);this.visible(apple,.69,1);this.travel(apple,[[0,0,0],[.68,0,0],[1,tap?-55:40,0,tap?-250:250]]);
          break;
        }
        case 'aura': case 'electric': case 'powercard': {
          const ring=this.svg('ellipse',{cx:89,cy:137,rx:68,ry:77,fill:'#edc256',opacity:'.15',stroke:'#dd9c34','stroke-width':5});
          this.canvas.insertBefore(ring,s.root);this.pop(ring,.21);this.wobble(s.motion,.35,5);
          this.burst(94,58);
          const spark=this.prop('spark',92,29,27,36);this.pop(spark,.41);
          if(mode==='electric') {const shirt=center('shirt',78,107);this.wobble(shirt,.4,5);}
          if(mode==='powercard'){const card=center('card',64,109);const meter=right('meter',57);this.wobble(card,.3,4);this.pop(this.prop('smoke',261,100,53,48),.56);reaction(2);}
          if(tap)grin(5);break;
        }
        case 'measure': {
          center('robot',76,112);
          const ruler=this.prop('ruler',101,96,117,40);
          this.animate(ruler,[{transform:'scaleX(.1)',offset:0},{transform:'scaleX(1)',offset:.45},{transform:'scaleX(.23)',offset:.72},{transform:'scaleX(.23)',offset:1}]);
          reaction(tap?3:2,.66);break;
        }
        case 'alchemy': {
          const circle=this.svg('g');
          this.svg('circle',{cx:185,cy:153,r:48,fill:'#b986b91a',stroke:'#b997c8','stroke-width':3},circle);
          this.svg('path',{d:'M185 106 228 177H142Z',fill:'none',stroke:'#c9a8d4','stroke-width':2},circle);
          this.wobble(circle,.24,22);
          const sword=center('sword');this.visible(sword,0,.43);
          const cup=center('mug',67,131);this.pop(cup,.44);reaction(3,.53);grin(0);
          if(tap)this.travel(cup,[[0,0,0],[.5,72,-12,-12],[1,72,-12,-12]]);
          break;
        }
        case 'hat': {
          const owl=center('owl',52,144);this.pop(owl,.43);
          const hat=center('hat',88,112);this.travel(hat,[[0,0,0],[.42,0,-55],[.72,0,-55],[1,0,tap?-58:0]]);
          if(tap){const letter=center('letter',53,155);this.pop(letter,.42);}
          break;
        }
        case 'jojo': {
          const glyph=this.prop('glyph',124,57,79,122);this.pop(glyph,.24);
          this.travel(s.motion,[[0,-14,0],[.28,0,0,-9],[.44,0,-4,-15],[.67,0,0,tap?18:-12],[1,0,0,tap?18:-12]]);
          if(tap)reaction(2,.5);this.wobble(d.motion,.55,10);break;
        }
        case 'giant': {
          s.root.style.opacity='.8';
          const left=this.prop('hand',145,110,75,88,'#c7815a');
          const eye=this.prop('eye',172,41,127,77);
          this.travel(left,[[0,0,115],[.4,0,0],[1,0,0]]);
          this.pop(eye,.43);if(tap)this.animate(eye,[{transform:'scaleY(1)',offset:0},{transform:'scaleY(.05)',offset:.5},{transform:'scaleY(1)',offset:.65},{transform:'scaleY(1)',offset:1}]);break;
        }
        case 'rope': case 'web': {
          const rope=this.path('M90 0V180',mode==='web'?'#abb9b8':'#b58d55',3);
          this.canvas.insertBefore(rope,s.root);
          this.travel(s.motion,mode==='web'?[[0,0,-200,180],[.42,0,-4,180],[.7,0,-4,180],[1,0,-200,180]]:[[0,0,-22],[.5,0,175],[.78,0,135],[1,0,135]]);
          const prop=center(mode==='web'?'helmet':'lamp',44,161);this.pop(prop,.57);
          if(tap)this.wobble(prop,.65,20);break;
        }
        case 'lift': {
          const base=center('plinth',94,122);this.travel(base,[[0,0,20],[.3,0,17],[.42,0,20],[.68,0,-13],[1,0,-13]]);
          reaction(7,.7);this.travel(d.motion,[[0,0,0],[.48,-14,0],[.7,-14,-10],[1,-14,-10]]);
          this.pop(this.prop('star',140,70,33,33),.72);break;
        }
        case 'clones': case 'scroll': {
          if(mode==='scroll')center('scroll',105,119);
          const clone1=this.actor(4,119,74,94,127),clone2=this.actor(6,203,103,95,111);
          d.root.style.opacity='.0';
          this.visible(clone1.root,.3,1);this.visible(clone2.root,.4,1);
          this.pop(this.prop('smoke',126,125,100,65),.23);
          const z=this.word(tap?'…':'z z',261,93,14);this.visible(z,.55,1);
          if(tap)this.wobble(clone2.motion,.35,5);
          if(mode==='scroll')this.pop(this.prop('stamp',219,139,42,48),.61);
          break;
        }
        case 'straw': {
          const hat=this.prop('straw',275,145,67,48);
          this.travel(hat,[[0,20,0,32],[.35,-133,12,-100],[.58,-140,10,-110],[.85,-62,-53,0],[1,-62,-53,tap?-16:0]]);
          const arm=this.path('M357 185Q228 192 183 163','#dfab72',13);this.visible(arm,.4,.84);
          const hand=this.prop('hand',167,143,33,33,'#e6b77e');this.visible(hand,.42,.84);
          if(p.includes('shirt'))this.prop('shirt',61,105,53,65);break;
        }
        case 'team': case 'squad': {
          s.root.style.opacity='.0';
          for(let i=0;i<5;i++){
            const unit=this.prop(mode==='team'?'meeple':'helmet',31+i*50,140,43,59,['#a14136','#396a96','#b79b42','#6e4380','#48704d'][i]);
            this.travel(unit,[[0,0,55],[.24+i*.04,0,0],[.55,0,0],[.72,0,-5,tap?12:0],[1,0,0]]);
          } grin(1);break;
        }
        case 'rocket': {
          const fist=this.prop('robot_hand',10,126,63,65);
          this.travel(fist,[[0,-100,0],[.33,270,-22],[.7,120,0],[1,120,0]]);
          const tool=center('screwdriver',51,137);this.pop(tool,.72);
          reaction(7,.73);break;
        }
        case 'bobble': {
          s.root.style.opacity='0';
          const body=this.svg('svg',{x:68,y:133,width:61,height:68,viewBox:'88 145 160 188',overflow:'hidden'});
          this.svg('image',{href:this.dataset.atlas,width:1254,height:1254},body);
          const head=this.svg('svg',{x:35,y:41,width:124,height:120,viewBox:'72 0 200 170',overflow:'hidden'});
          this.svg('image',{href:this.dataset.atlas,width:1254,height:1254},head);
          this.travel(head,[[0,0,0,-4],[.2,0,4,7],[.37,0,-2,-5],[.54,0,3,4],[.72,0,-1,-2],[1,0,0]]);
          center('plinth',78,176);if(tap)grin(0);break;
        }
        case 'moon': {
          const moon=this.prop('moon',135,26,90,90);this.pop(moon,.15);
          this.burst(188,73,'#d2b8df');
          const bow=this.prop('bow',72,111,46,39);this.pop(bow,.46);
          const star=this.prop('star',92,27,23,23);this.pop(star,.65);
          if(tap)this.wobble(s.motion,.52,10);break;
        }
        case 'armor': case 'helmet': {
          const helmet=this.prop('helmet',64,31,67,75);
          this.travel(helmet,[[0,0,-150],[.44,0,0,mode==='armor'?180:0],[.6,0,12,mode==='armor'?180:0],[1,0,tap?-13:12,tap?0:(mode==='armor'?180:0)]]);
          reaction(2,.54);
          if(mode==='armor'){const chest=center('chest',65,148);this.wobble(chest,.26,6);const shield=this.prop('shield',131,138,35,40);this.pop(shield,.33);}
          break;
        }
        case 'equip': case 'sword': {
          const sword=center('sword',mode==='equip'?110:80,mode==='equip'?83:120);
          this.travel(sword,[[0,-20,15,-30],[.32,0,0,20],[.6,0,mode==='equip'?25:0,mode==='equip'?40:-25],[1,0,0,tap?0:20,tap?.65:1]]);
          reaction(mode==='equip'?2:7,.6);
          if(mode==='sword'){const confetti=this.prop('confetti',166,101,61,65);this.visible(confetti,.44,1);this.travel(confetti,[[0,0,0],[.44,0,0],[1,0,65]]);}
          break;
        }
        case 'force': case 'spoon': {
          const prop=center(mode==='spoon'?'mug':p[0],71,130);
          this.travel(prop,[[0,0,14],[.35,0,-35],[.63,0,-39],[.8,tap?-54:0,-28],[1,tap?-54:0,-28]]);
          const string=this.path('M244 104Q209 88 180 123','#928d80',1);this.visible(string,.55,.8);
          grin(2);if(mode==='spoon'){const wand=this.prop('pencil',266,119,44,50);this.wobble(wand,.4,18);}
          break;
        }
        case 'meeples': {
          s.root.style.opacity='0';
          const red=this.prop('meeple',48,135,58,66,'#b75040'),blue=this.prop('meeple',130,135,58,66,'#4b7f9b');
          center('chair',57,138);
          this.travel(red,[[0,-20,0],[.4,29,0],[.62,-2,0],[1,-2,0]]);
          this.travel(blue,[[0,0,0],[.4,-24,0],[.62,10,0],[1,10,0]]);
          this.pop(this.prop('chair',238,163,54,48),.55);this.wobble(d.motion,.58,4);break;
        }
        case 'map': case 'mapbook': case 'robotmap': case 'mapgift': {
          const map=center('map',101,113);
          this.travel(map,[[0,0,0],[.35,0,0],[.7,0,0,tap?0:180],[1,0,0,tap?0:180]]);
          if(mode==='mapbook'){
            this.prop('book',135,156,108,55);
            this.animate(map,[{transform:'scaleY(.1)',offset:0},{transform:'scaleY(1)',offset:.5},{transform:'scaleY(1)',offset:1}]);
            const a=this.prop('arrow',137,113,32,32),b=this.prop('arrow',211,113,32,32);this.visible(a,.51,1);this.visible(b,.51,1);
            if(tap)this.wobble(b,.61,24);
          } else if(mode==='robotmap'){const robot=this.prop('robot',161,117,63,81);this.travel(robot,[[0,30,0],[.5,-15,0],[.8,0,0],[1,0,0]]);}
          else if(mode==='mapgift'){this.pop(this.prop('gift',248,142,57,58),.4);this.prop('bow',266,70,43,43);}
          else this.pop(this.prop('meeple',179,130,33,40,'#71945d'),.4);
          reaction(3,.73);break;
        }
        case 'cards': case 'single': case 'album': case 'sleeve': {
          if(mode==='cards')this.prop('mat',133,173,115,37);
          if(mode==='album')center('book',118,128);
          if(mode==='sleeve')center('sleeve',73,111);
          for(let i=0;i<(mode==='sleeve'?1:3);i++){
            const card=this.prop('card',137+i*22,mode==='sleeve'?101:125,51,73);
            this.travel(card,[[0,0,mode==='sleeve'?-77:20,i*4-5],[.45,0,mode==='sleeve'?13:0,i*8-9],[.75,mode==='single'&&i===2?34:0,mode==='single'&&i===2?-13:0,i*8-9],[1,0,mode==='sleeve'?11:0,i*8-9]]);
          }
          if(mode==='cards' && c.path.includes('giochi-da-tavolo')){
            const card=this.prop('card',87,72,29,40);this.pop(card,.46);reaction(3,.53);
          } else if(mode==='cards') {
            const card=right('card',39);this.travel(card,[[0,0,0],[.5,40,0],[1,40,0]]);grin(2);
          }
          if(mode==='sleeve'&&tap)this.pop(this.prop('deck',221,148,53,59),.42);
          if(mode==='album')this.burst(182,145,'#93c9d2');
          break;
        }
        case 'shapes': case 'puzzle': {
          for(let i=0;i<4;i++){
            const piece=this.prop('puzzle',144+(i%2)*33,130+Math.floor(i/2)*33,38,38,['#9b5f42','#5a8591','#c99d53','#8c657e'][i]);
            this.travel(piece,[[0,(i%2?1:-1)*45,(i<2?-1:1)*28,i*90],[.4+(i===3?.3:0),0,0,0],[1,0,0,0]]);
          }grin(7);if(tap)this.burst(181,161);break;
        }
        case 'portal': {
          const portal=this.prop('portal',151,62,91,147);
          this.canvas.insertBefore(portal.parentNode,s.root);
          this.travel(d.motion,[[0,-96,0,0,.3],[.43,-74,0,0,1.15],[.62,-74,0,12,.8],[1,tap?-7:-36,0,0,.8]]);
          reaction(2,.4);break;
        }
        case 'mystery': case 'magnify': {
          center(mode==='mystery'?'cookie':'book',74,132);
          const lens=this.prop('magnifier',132,108,72,87);
          this.travel(lens,[[0,-80,0],[.45,36,0],[.7,63,0],[1,63,0]]);
          if(mode==='magnify')this.prop('glasses',251,103,50,24);
          grin(mode==='mystery'?2:1);if(tap)this.pop(this.prop('cookie',288,164,18,18),.55);break;
        }
        case 'party': case 'trivia': {
          const a=center(mode==='party'?'mug':'sign',83,114);
          this.travel(a,[[0,0,35],[.37,0,0],[.6,0,0,mode==='party'?35:0],[1,0,0,mode==='party'?-10:0]]);
          if(mode==='party')reaction(2,.56);
          else {const mark=this.word(tap?'?':'!',185,151,27);this.pop(mark,.42);reaction(7,.54);}
          break;
        }
        case 'roll': {
          center('d20',61,151);
          this.travel(d.motion,[[0,22,0],[.25,-35,0],[.48,-82,5,180,.8],[.75,-107,0,360,.8],[1,-107,0,360,.8]]);
          if(tap)this.wobble(s.motion,.6,6);break;
        }
        case 'clap': case 'music': case 'record': case 'popcorn': {
          const prop=center(mode==='record'?'vinyl':'clapper',89,115);
          if(mode==='record')this.animate(prop,[{transform:'rotate(0deg)'},{transform:'rotate(360deg)'}],{duration:DURATION,easing:'linear'});
          else this.wobble(prop,.32,20);
          if(mode==='record'){const needle=this.prop('needle',194,111,43,51);this.travel(needle,[[0,22,0,-25],[.5,0,0],[1,0,0]]);}
          if(mode==='music'){const vinyl=this.prop('vinyl',140,142,47,47);this.wobble(vinyl,.55,35);}
          if(mode==='popcorn'){const bowl=this.prop('popcorn',77,114,96,92);this.pop(bowl,.3);if(tap)this.pop(this.prop('popcorn',260,132,26,26),.5);}
          if(tap)this.wobble(d.motion,.4,9);break;
        }
        case 'zombie': {
          const hand=this.prop('hand',137,171,61,70,'#8f9e68');this.travel(hand,[[0,0,71],[.38,0,-30],[1,0,-30]]);
          const meeple=center('meeple',35,130);this.travel(meeple,[[0,71,0],[.47,7,0],[.67,64,0],[1,64,0]]);
          if(tap)this.pop(center('book',60,116),.54);break;
        }
        case 'dress': case 'runway': {
          const shirt=this.prop('shirt',63,104,70,87);this.pop(shirt,.34);
          if(mode==='dress'){const curtain=this.prop('curtain',16,33,142,170);this.visible(curtain,0,.33);}
          this.wobble(s.motion,.45,tap?15:6);reaction(7,.41);
          if(mode==='runway'){const sign=right('sign',55);this.pop(sign,.54);this.word('✓',279,166,19);}
          break;
        }
        case 'hood': {
          const hood=this.prop('hood',226,64,105,125);
          this.travel(hood,[[0,0,-140],[.39,0,0],[.71,0,0],[1,0,tap?-28:-5]]);
          grin(4,.56);break;
        }
        case 'hats': {
          for(let i=0;i<3;i++){
            const hat=this.prop(p[i],62,40-i*16,79,60);
            this.travel(hat,[[0,0,-140-i*30],[.3+i*.15,0,0],[1,tap&&i<2?170:0,tap&&i<2?45:0]]);
          }reaction(2,.68);break;
        }
        case 'bag': {
          const bag=center('bag',81,118);
          const die=this.prop('d20',152,31,68,65);this.travel(die,[[0,0,0],[.4,0,89,60,.15],[1,0,89,60,.15]]);
          const extra=this.prop(p[2]||'tent',168,91,50,50);this.pop(extra,.62);this.wobble(bag,.53,6);reaction(2,.65);break;
        }
        case 'gift': case 'new': case 'ribbon': case 'spring': case 'yoyo': {
          const gift=center('gift',83,128);this.wobble(gift,.25,8);
          if(mode==='spring'){const spring=center('spring',69,74);this.pop(spring,.41);reaction(2);grin(3);}
          else if(mode==='yoyo'){const yoyo=center('yoyo',42,125);this.travel(yoyo,[[0,30,-30],[.42,0,30],[.65,0,-20],[1,0,-20]]);}
          else{
            const bow=this.prop('bow',151,107,77,52);this.travel(bow,[[0,0,0],[.47,0,-45,20],[.66,30,-33,-15],[1,tap?60:30,tap?-24:-33,-15]]);
            if(mode==='gift'&&c.path==='/collections/gadget-e-accessori'){this.travel(d.motion,[[0,-88,0,0,.25],[.35,-48,0,0,.25],[.68,0,0],[1,0,0]]);}
            if(mode==='ribbon'){reaction(2,.4);this.path('M43 102Q124 78 128 149Q15 174 45 120','#c49a4b',7);}
            if(mode==='new')this.burst(183,106);
          }break;
        }
        case 'mug': case 'steam': {
          const mug=center('mug',78,133);
          if(mode==='mug'){
            const flame=this.prop('flame',210,132,46,33);this.pop(flame,.24);this.visible(flame,.22,.7);
            const marsh=this.prop('marshmallow',107,93,88,83);this.travel(marsh,[[0,-30,0],[.48,12,0],[1,12,0,tap?9:0,tap?1.18:1]]);
          }else{
            const smoke=this.actor(8,152,68,67,72);smoke.root.style.opacity='.33';this.pop(smoke.motion,.34);
            this.travel(smoke.motion,[[0,0,35,0,.4],[.5,0,0],[1,0,-20,0,.9]]);grin(2,.5);
          }
          if(tap)this.wobble(mug,.4,4);break;
        }
        case 'picture': {
          const frame=center('picture',99,81);this.travel(frame,[[0,0,0,13],[.52,0,0,13],[.64,0,0,0],[1,0,0,tap?-3:0]]);
          if(tap)this.pop(center('ruler',101,161),.4);break;
        }
        case 'lamp': {
          const glow=this.svg('ellipse',{cx:267,cy:143,rx:68,ry:70,fill:'#efc761',opacity:'.24'});this.canvas.insertBefore(glow,d.root);this.pop(glow,.34);
          center('lamp',65,130);this.prop('cookie',263,142,35,35);grin(3,.43);
          if(tap)glow.setAttribute('fill','#d896bd');break;
        }
        case 'pencil': {
          const pencil=center('pencil',73,99);this.travel(pencil,[[0,-8,0],[.3,13,18],[.5,-6,35],[.68,22,50],[1,22,50]]);
          const miniature=this.actor(8,133,142,60,61);this.pop(miniature.motion,.48);
          const eraser=right('eraser',30);this.travel(eraser,[[0,0,0],[.59,0,0],[.81,-94,18],[1,-94,18]]);
          break;
        }
        case 'keys': case 'swing': {
          const ring=this.svg('circle',{cx:183,cy:89,r:19,fill:'none',stroke:'#c9b781','stroke-width':5});
          const key=center('key',mode==='keys'?86:64,111);this.wobble(key,.29,tap?22:13);
          if(mode==='keys'){for(let i=0;i<3;i++)this.prop('key',159+i*15,114+i*9,40,58);const tiny=this.prop('key',247,148,22,26);this.pop(tiny,.57);}
          else this.travel(d.motion,[[0,0,0],[.38,-21,0,-7],[.59,5,0,7],[1,0,0]]);
          this.wobble(ring,.28,3);break;
        }
        case 'plush': {
          this.pose(d,14,.01);
          const plush=right('plush',48);this.travel(plush,[[0,0,0],[.36,-13,0],[.55,36,20],[1,tap?-12:36,tap?-2:20]]);
          this.wobble(d.motion,.56,tap?5:3);break;
        }
        case 'dart': {
          const shield=this.prop('shield',87,110,65,79);
          const dart=this.prop('dart',122,122,52,42);this.travel(dart,[[0,200,-43,-12],[.32,200,-43,-12],[.44,0,0,-12],[1,0,0,-12]]);
          this.wobble(shield,.44,9);reaction(2,.59);
          if(tap){const extra=right('dart',35);this.travel(extra,[[0,0,0],[.5,-27,52,190],[1,-27,52,190]]);}break;
        }
        case 'capsule': case 'ballgift': {
          const capsule=center(mode==='ballgift'?'pokeball':'capsule',91,121);
          this.wobble(capsule,.19,13);
          this.animate(capsule,[{opacity:1,offset:0},{opacity:1,offset:.39},{opacity:.25,offset:.47},{opacity:.25,offset:1}]);
          if(mode==='capsule'){const mini=this.actor(4,161,123,64,74);this.pop(mini.motion,.46);if(tap)this.wobble(mini.motion,.54,16);}
          else{const key=center('key',48,149);this.pop(key,.46);this.wobble(key,.65,9);}
          break;
        }
        case 'advent': {
          center('calendar',92,111);
          const flap=this.svg('rect',{x:165,y:157,width:21,height:29,fill:'#e5b563'});
          this.animate(flap,[{transform:'scaleX(1)',offset:0},{transform:'scaleX(.05)',offset:.44},{transform:'scaleX(1)',offset:.73},{transform:'scaleX(1)',offset:1}]);
          const star=this.prop('star',165,153,24,25);this.visible(star,.44,tap?1:.72);
          this.travel(d.motion,[[0,0,0],[.42,-25,0,-7],[.75,0,0],[1,0,0]]);break;
        }
        case 'comics': case 'manga': {
          const panel=this.prop('panel',122,104,121,103);
          if(mode==='manga'){
            const arrow=this.prop('arrow',154,70,44,30);arrow.style.transform='rotate(180deg)';
            this.travel(s.motion,[[0,27,0],[.3,53,0],[.65,-8,0],[1,-8,0]]);
          }else{
            for(let i=0;i<3;i++){const word=this.word(['BAM','POW',ui.oops][i],147+i*35,106+i*27,i===2?22:17);this.pop(word,.22+i*.15);}
            reaction(2,.56);
          }
          if(tap)this.wobble(panel,.5,5);break;
        }
        case 'books': case 'boxset': case 'manual': {
          if(mode==='boxset')center('boxset',112,105);
          for(let i=0;i<4;i++){
            const book=this.prop('book',mode==='boxset'?149+i*15:137,mode==='boxset'?118:171-i*22,mode==='boxset'?33:96,mode==='boxset'?78:34);
            this.travel(book,[[0,0,-130-i*23,i===3&&mode==='boxset'?13:0],[.24+i*.12,0,0,i===3&&mode==='boxset'?13:0],[.8,0,0],[1,0,0]]);
          }
          if(mode==='manual')this.pop(this.prop('bookmark',200,104,36,79,'#a34337'),.55);
          if(tap)this.pop(this.prop('bookmark',235,126,29,63,'#9a583e'),.3);
          reaction(mode==='books'?2:7,.75);break;
        }
        case 'bookmarks': {
          center('book',119,119);
          const a=this.prop('bookmark',140,97,42,85,'#9d5368'),b=this.prop('bookmark',214,97,42,85,'#608899');
          this.travel(a,[[0,0,0],[.5,25,0],[1,tap?30:25,0]]);
          this.travel(b,[[0,0,0],[.5,-25,0],[1,tap?-30:-25,0]]);
          const page=this.svg('rect',{x:141,y:105,width:105,height:96,rx:5,fill:'#f4e4c0',stroke:'#bba071','stroke-width':2});
          this.visible(page,tap?.79:.59,tap?.8:1);reaction(3,.65);break;
        }
        case 'reading': case 'narrative': case 'popup': {
          const book=center('book',108,122);
          if(mode==='reading'){
            right('mug',37);
            const mark=this.prop('bookmark',175,121,25,69,'#ac4d36');this.travel(mark,[[0,0,0],[.52,30,0],[1,30,0]]);reaction(3,.58);
          }
          if(mode==='narrative'){const pen=this.prop('pen',147,84,62,59);this.wobble(pen,.35,19);this.travel(d.motion,[[0,0,0],[.45,-33,-3,-7],[.73,0,0],[1,0,0]]);}
          if(mode==='popup'){const castle=this.prop('castle',148,72,92,89);this.pop(castle,.39);this.travel(d.motion,[[0,0,0],[.62,-28,-18,-10],[1,-28,-18,-10]]);}
          if(tap)this.wobble(book,.53,5);break;
        }
        case 'fog': {
          this.prop('moon',155,30,59,66);
          for(let i=0;i<3;i++){const cloud=this.prop('smoke',105+i*49,148,89,45);cloud.style.opacity='.42';this.travel(cloud,[[0,-25,0],[1,15,0]]);}
          const lamp=center('lamp',55,127);this.pop(lamp,.33);reaction(2,.57);
          if(tap)this.pop(this.prop('spark',171,131,14,21),.3);break;
        }
        case 'paint': case 'primer': {
          const mini=this.actor(7,154,118,54,67);
          this.prop('plinth',148,176,65,27);
          if(mode==='primer')mini.root.style.filter='grayscale(1)';
          const brush=this.prop('brush',199,70,78,111);this.travel(brush,[[0,30,-38],[.49,0,0,-24],[.69,0,7,-34],[1,0,7,-34]]);
          const drop=this.prop('drop',94,75,13,17,'#4c91a2');this.pop(drop,.62);
          reaction(tap?3:2,.69);break;
        }
        case 'robot': case 'mecha': {
          const robot=center('robot',90,108);this.pop(robot,.35);
          for(let i=0;i<3;i++){const piece=this.prop('screw',115+i*25,138,24,29);this.travel(piece,[[0,(i-1)*42,-40],[.37,20,0],[1,20,0]]);this.visible(piece,0,.39);}
          const extra=this.prop(mode==='robot'?'screw':'rod',235,177,32,32);this.pop(extra,.66);
          reaction(mode==='robot'?3:7,.71);if(tap)grin(1);break;
        }
        case 'd20': case 'critical': {
          const die=this.prop('d20',135,143,69,69);
          this.travel(die,[[0,-160,-12,-520],[.35,-17,-32,-55],[.53,0,0,0],[1,0,0,0]]);
          const value=this.word(mode==='d20'?'1':'20',170,184,21);value.setAttribute('fill','#fff0ca');this.visible(value,.54,1);
          if(mode==='d20'){reaction(6,.58);this.travel(s.motion,[[0,0,0],[.52,0,0],[.68,tap?-7:54,0],[1,tap?-7:54,0]]);grin(5,.67);}
          else{reaction(7,.59);this.wobble(s.motion,.65,7);const hand=this.prop('hand',187,148,38,35,'#c76e50');this.pop(hand,.72);}
          break;
        }
        case 'mimic': {
          const chest=center('chest',109,103);
          const mouth=this.svg('g');
          this.svg('path',{d:'M150 143Q199 156 246 143L242 172Q198 183 154 172Z',fill:'#382523',stroke:'#532d25','stroke-width':3},mouth);
          this.svg('path',{d:'m158 148 7 15 7-12 9 16 8-13 9 15 9-14 9 12 7-14 9 12 7-14',fill:'#f4dcaa',stroke:'#f4dcaa','stroke-width':2},mouth);
          for(let i=0;i<2;i++){this.svg('ellipse',{cx:176+i*44,cy:138,rx:9,ry:6,fill:'#f6d379'},mouth);this.svg('circle',{cx:178+i*40,cy:138,r:3,fill:'#352822'},mouth);}
          this.visible(mouth,.4,tap?.75:1);reaction(2,.44);
          this.travel(s.motion,[[0,0,0],[.4,0,0],[.56,-22,0,-8],[1,-22,0,-8]]);
          if(tap)this.wobble(chest,.55,8);break;
        }
        case 'master': {
          for(let i=0;i<4;i++){const paper=this.prop('paper',154+i*8,110-i*9,58,69);this.wobble(paper,.26+i*.06,4);}
          center('screen',124,126);
          if(tap){const paper=this.prop('paper',220,126,40,45);this.travel(paper,[[0,0,-20],[.7,19,43,57],[1,19,43,57]]);this.word('?',251,181,19);}
          grin(2);break;
        }
        case 'ship': case 'ships': {
          const ship=this.prop(mode==='ship'?'ship':'ship_space',122,110,110,93);
          this.travel(ship,[[0,-80,12,-7],[.3,-15,-6,5],[.56,0,10,-5],[.77,10,0,4],[1,tap?-25:10,0,0]]);
          if(mode==='ship'){const don=this.prop('don',226,146,37,51);this.pop(don,.34);this.path('M103 202q14-12 28 0t28 0t28 0t28 0','#6197ad',4);}
          else {const second=this.prop('ship_space',290,56,48,62);this.travel(second,[[0,60,-50],[.4,-70,0],[.7,-100,20],[1,-140,20]]);right('rod',33);}
          break;
        }
        case 'runes': {
          const rune=center('rune',77,83);this.pop(rune,.21);
          const field=this.svg('ellipse',{cx:192,cy:193,rx:65,ry:17,fill:'#78967f',stroke:'#536a51','stroke-width':3});this.canvas.insertBefore(field,s.root);
          const flag=this.prop('flag',187,120,52,76,'#aa453b');this.pop(flag,.47);
          if(tap){const other=this.prop('flag',152,125,43,71,'#4b809c');this.pop(other,.34);this.travel(flag,[[0,0,0],[.65,43,0],[1,43,0]]);}reaction(3,.57);break;
        }
        case 'ball': {
          const ball=center('pokeball',94,120);
          this.wobble(ball,.18,18);
          this.travel(d.motion,[[0,0,0],[.3,-12,0],[.53,-94,-10,0,.78],[.74,-78,0,0,.92],[1,-78,0,0,.92]]);
          this.animate(ball,[{opacity:1,offset:0},{opacity:1,offset:.45},{opacity:.45,offset:.52},{opacity:1,offset:.71},{opacity:1,offset:1}]);
          reaction(2,.64);
          if(tap)this.wobble(d.motion,.48,12);break;
        }
        case 'duel': case 'dueldisk': {
          const first=this.prop(mode==='duel'?'sword':'disk',112,106,89,90);
          this.pop(first,.25);this.wobble(first,.47,12);
          const card=this.prop('card',184,91,53,76);this.pop(card,.46);
          if(mode==='duel')this.prop('shield',73,111,58,72);
          else reaction(tap?2:4,.54);
          if(tap)this.wobble(s.motion,.6,15);break;
        }
        case 'mana': {
          const colors=['#ddd4ac','#729ab7','#766775','#cc634b','#719460'];
          for(let i=0;i<5;i++){
            const a=i*Math.PI*2/5;
            const orb=this.svg('circle',{cx:183+Math.cos(a)*49,cy:132+Math.sin(a)*43,r:9,fill:colors[i],stroke:'#f1dcba','stroke-width':2});
            this.pop(orb,.1+i*.04);
          }
          const card=center('card',56,100);this.pop(card,.2);
          const sign=this.prop('sign',212,135,117,67);this.pop(sign,.48);
          const text=this.word(tap?ui.resolves:ui.response,270,161,12);this.visible(text,.55,1);
          reaction(tap?7:3,.59);if(tap)this.burst(187,132);break;
        }
        case 'suits': {
          for(let i=0;i<4;i++){const suit=this.prop('suit',107+i*36,142,31,37,i%2?'#3a3836':'#b5483d');this.pop(suit,.15+i*.1);}
          const cap=this.prop('cap',145,89,77,53);this.pop(cap,.64);grin(2);if(tap)this.wobble(cap,.5,16);break;
        }
        case 'ink': {
          center('ink',67,144);
          const drop=this.prop('drop',159,62,35,58,'#8974b1');this.travel(drop,[[0,0,60,0,.2],[.35,0,0],[.57,0,0,0,1.2],[1,0,tap?70:0,0,tap?.3:1]]);
          this.burst(179,99,'#ae8ec8');this.pop(this.prop('drop',119,132,13,17,'#8974b1'),.58);reaction(2,.62);break;
        }
        case 'forge': {
          for(let i=0;i<3;i++){const key=this.prop('key',112+i*36,104,43,54);this.pop(key,.14+i*.14);}
          center('chest',91,147);
          const lock=this.prop('lock',246,151,39,43);this.pop(lock,.63);
          if(tap)this.travel(lock,[[0,0,0],[.6,67,3,20],[1,67,3,20]]);
          reaction(3,.72);grin(5);break;
        }
        case 'blocks': case 'lego': {
          const brick=this.prop('brick',119,183,40,28);
          if(mode==='lego'){
            this.pose(s,0,0.01);
            this.travel(s.motion,[[0,-25,0],[.3,24,0],[.45,24,-18],[.58,24,0],[.7,24,-10],[1,24,0]]);
            this.pose(s,tap?7:5,.41);
            const slipper=this.prop('slipper',199,159,57,42);this.travel(slipper,[[0,62,0],[.54,62,0],[.83,-22,19],[1,-22,19]]);
            if(tap)this.prop('slipper',102,182,42,30);
          } else{
            for(let i=0;i<3;i++){const block=this.prop('brick',141,163-i*25,72,45);this.travel(block,[[0,0,-120-i*15],[.24+i*.13,0,0],[1,0,0]]);}
            const hat=this.prop('brick',254,87,42,33);this.pop(hat,.63);if(tap)this.travel(hat,[[0,0,0],[.6,-114,29],[1,-114,29]]);
          }break;
        }
        case 'lights': {
          const prop=center(p[0],79,124);
          for(let i=0;i<3;i++){const bulb=this.prop('bulb',127+i*44,42,28,43,['#d77c65','#b6ba68','#77b0ba'][i]);this.pop(bulb,.15+i*.12);}
          this.travel(prop,[[0,0,0],[.49,0,0],[.69,0,0,180],[1,0,0,tap?0:180]]);reaction(3,.73);break;
        }
        case 'launch': case 'launcher': case 'arena': case 'legacy_battle': {
          if(mode==='arena')this.prop('arena',115,118,142,85);
          const top=this.prop('top',mode==='arena'?130:101,mode==='arena'?134:156,49,49);
          this.animate(top,[{transform:'rotate(0deg)'},{transform:'rotate(2520deg)'}],{duration:DURATION,easing:'linear'});
          const orbit=this.svg('g');
          orbit.append(top.parentNode);
          this.travel(orbit,[[0,-15,0],[.3,30,-8],[.55,95,0],[.8,35,12],[1,35,12]]);
          if(mode==='arena'||mode==='legacy_battle'){
            const other=this.prop('top',232,151,42,42);other.style.filter='hue-rotate(130deg)';
            this.travel(other,[[0,0,0],[.45,-68,-16,480],[.65,-45,8,960],[1,0,0,1680]]);
            this.burst(212,164);
          }else{const launcher=this.prop('launcher',85,125,64,48);this.wobble(launcher,.27,17);if(mode==='launcher'&&!tap){this.visible(top,0,.04);reaction(3,.49);}else reaction(7,.48);}
          break;
        }
        case 'waiting': {
          const glass=center('hourglass',65,109);this.wobble(glass,.46,8);
          this.prop('plinth',238,173,83,37);
          if(tap)this.pop(this.prop('brush',239,120,51,72),.37);break;
        }
        case 'legacy_hot': case 'legacy_hot_fan': {
          s.root.style.opacity='0';
          const guest=document.querySelector('[data-fx-image="hot"]');
          if(guest){
            const image=this.svg('image',{href:guest.getAttribute('src'),x:25,y:31,width:145,height:176});
            this.travel(image,[[0,-150,0],[.2,0,0],[1,0,0]]);
          }
          const fan=this.prop('fan',241,102,68,75);this.pop(fan,.41);this.wobble(fan,.47,tap?22:13);break;
        }
        default: throw new Error('Missing sketch recipe: '+mode);
      }
      finish();
      this.dataset.objects = String(this.canvas.querySelectorAll('use').length);
    }
    setupLab(signal) {
      if(!this.lab) return;
      const lab=this.querySelector('.eg-lab');
      lab.hidden=false;
      lab.querySelector('[data-eg-hide]').addEventListener('click',()=>{lab.hidden=true;},{signal});
      const select=lab.querySelector('[data-eg-select]');
      for(const route of this.config.routes) {
        const option=document.createElement('option');
        option.value=route.id;
        option.textContent=route.title+' — '+route.path.replace('/collections/','')+(route.theme?' / '+route.theme:'');
        select.append(option);
      }
      const selected=()=>this.config.routes.find(route=>route.id===select.value);
      lab.querySelector('[data-eg-play]').addEventListener('click',()=>this.play(selected()),{signal});
      lab.querySelector('[data-eg-pause]').addEventListener('click',()=>this.seek(Number(lab.querySelector('[data-eg-frame]').value)/100),{signal});
      lab.querySelector('[data-eg-frame]').addEventListener('input',event=>this.seek(Number(event.target.value)/100),{signal});
      select.addEventListener('change',()=>this.play(selected()),{signal});
      lab.querySelector('[data-eg-reset]').addEventListener('click',()=>{
        for(const route of this.config.routes) { try {sessionStorage.removeItem('emporio-gags-v2:'+route.id);}catch(_){} }
        this.play(selected());
      },{signal});
      lab.querySelector('[data-eg-audit]').addEventListener('click',()=>{
        this.stop();
        const failures=[];
        this.dryRun=true;
        for(const route of this.config.routes){
          for(const tap of [false,true]){
            try{this.canvas.replaceChildren();this.build(route,tap);}
            catch(error){failures.push(route.id+': '+error.message);}
          }
        }
        this.dryRun=false;
        this.canvas.replaceChildren();
        const output=lab.querySelector('[data-eg-result]');
        output.textContent=failures.length?failures.join('\n'):this.config.routes.length+' scene + '+this.config.routes.length+' reazioni: OK';
        output.dataset.audit=failures.length?'failed':'passed';
      },{signal});
    }
  }
  customElements.define('emporio-gags',EmporioGags);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-clothing-picks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emporio-clothing-picks')) {
    customElements.define('emporio-clothing-picks', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const list = this.querySelector('.emporio-picks__list');
        const buttons = this.querySelectorAll('[data-direction]');
        const update = () => {
          buttons[0].disabled = list.scrollLeft <= 2;
          buttons[1].disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          list.scrollBy({ left: list.clientWidth * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }));
        list.addEventListener('scroll', update, { passive:true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(list);
        update();
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); this.initialized = false; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-halloween-site"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('emporio-season-pumpkin'))customElements.define('emporio-season-pumpkin',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;this.querySelector('button').addEventListener('click',()=>{const message=this.querySelector('[role="status"]');message.textContent=this.dataset.message;message.hidden=false;clearTimeout(this.timer);this.timer=setTimeout(()=>message.hidden=true,3500);});}
 disconnectedCallback(){clearTimeout(this.timer);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-hot-mobile"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emporio-hot-mobile')) {
  customElements.define('emporio-hot-mobile', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.small = matchMedia('(max-width: 700px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.finished = false;
      this.generation = 0;
      this.dataset.state = 'idle';
      const begin = () => this.prepare();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { once: true, signal });
      else queueMicrotask(begin);
      window.addEventListener('pageshow', event => {
        if (event.persisted) { this.stop(); this.finished = false; this.dataset.state = 'idle'; this.prepare(); }
      }, { signal });
      window.addEventListener('pagehide', () => this.stop(), { signal });
      window.addEventListener('emporio:cart-added', () => this.stop(), { signal });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.stop(); }, { signal });
      document.addEventListener('focusin', event => {
        if (event.target.matches('input,textarea,select,[contenteditable="true"]')) this.stop();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.dataset.state === 'playing') this.stop();
        else if (!document.hidden && !this.finished) this.prepare();
      }, { signal });
      this.small.addEventListener('change', () => {
        if (!this.small.matches) this.stop();
        else if (!this.finished) this.prepare();
      }, { signal });
      this.motion.addEventListener('change', () => this.stop(), { signal });
    }
    utilityVisit() {
      const params = new URL(location.href).searchParams;
      const filtered = params.has('sort_by') || params.has('page') || Array.from(params.keys()).some(key => key.startsWith('filter.'));
      try { return filtered && sessionStorage.getItem('emporio-hot-mobile-v1:' + this.dataset.route) === '1'; }
      catch (_) { return false; }
    }
    blocked() {
      if (document.hidden || document.documentElement.classList.contains('m6pn-open')) return true;
      const selectors = 'dialog[open],[role="dialog"][aria-modal="true"],.fancybox__container,.m6pn.toggle,.popup-a[aria-hidden="false"],#shopify-pc__banner,#onetrust-banner-sdk';
      return Array.from(document.querySelectorAll(selectors)).some(node => {
        const box = node.getBoundingClientRect(), style = getComputedStyle(node);
        return box.width > 20 && box.height > 20 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      });
    }
    async prepare() {
      if (!this.isConnected || this.finished || !this.small.matches || this.dataset.state !== 'idle' || this.utilityVisit()) return;
      const guest = this.querySelector('.ehm-guest'), image = this.querySelector('.ehm-image');
      if (!guest || !image || !this.dataset.image) return;
      this.dataset.state = 'loading';
      const generation = ++this.generation;
      try {
        const url = new URL(this.dataset.image, location.href);
        url.searchParams.set('width', '480');
        image.src = url.href;
        const timeout = new Promise((_, reject) => { this.decodeTimer = setTimeout(() => reject(new Error('image timeout')), 8000); });
        await Promise.race([image.decode(), timeout]);
      } catch (_) {
        if (generation === this.generation) { this.stop(); this.dataset.state = 'image-error'; }
        return;
      } finally { clearTimeout(this.decodeTimer); }
      if (generation !== this.generation || !this.isConnected || !this.small.matches) return;
      this.dataset.state = 'waiting';
      this.deadline = performance.now() + 30000;
      this.timer = setTimeout(() => this.waitForSpace(generation, guest), 650);
    }
    waitForSpace(generation, guest) {
      if (generation !== this.generation || !this.isConnected || !this.small.matches || this.finished) return;
      if (performance.now() > this.deadline) { this.stop(); return; }
      if (this.blocked()) { this.timer = setTimeout(() => this.waitForSpace(generation, guest), 250); return; }
      this.play(guest);
    }
    play(guest) {
      this.hidden = false;
      this.dataset.state = 'playing';
      try { sessionStorage.setItem('emporio-hot-mobile-v1:' + this.dataset.route, '1'); } catch (_) {}
      this.observer = new MutationObserver(() => {
        if (this.dataset.state === 'playing' && this.blocked()) this.stop();
      });
      this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden', 'aria-modal'] });
      if (this.motion.matches || typeof guest.animate !== 'function') {
        guest.style.transform = 'translateX(6%)';
        guest.style.opacity = '1';
        this.timer = setTimeout(() => this.stop(), 1800);
        return;
      }
      guest.style.transform = '';
      guest.style.opacity = '';
      this.animation = guest.animate([
        { transform: 'translateX(118%) rotate(6deg)', opacity: 0, offset: 0 },
        { transform: 'translateX(42%) rotate(-7deg)', opacity: 1, offset: .17 },
        { transform: 'translateX(34%) rotate(-7deg)', opacity: 1, offset: .25 },
        { transform: 'translateX(34%) rotate(-7deg)', opacity: 1, offset: .49 },
        { transform: 'translateX(3%) rotate(-1deg)', opacity: 1, offset: .64 },
        { transform: 'translateX(3%) rotate(-1deg)', opacity: 1, offset: .82 },
        { transform: 'translateX(118%) rotate(6deg)', opacity: 0, offset: 1 }
      ], { duration: 4400, easing: 'ease-in-out', fill: 'both' });
      this.animation.onfinish = () => this.stop();
    }
    stop() {
      this.generation = (this.generation || 0) + 1;
      clearTimeout(this.timer);
      clearTimeout(this.decodeTimer);
      if (this.animation) { this.animation.onfinish = null; this.animation.cancel(); this.animation = null; }
      this.observer?.disconnect();
      this.observer = null;
      this.hidden = true;
      this.finished = true;
      this.dataset.state = 'done';
    }
    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-nerd-surprises"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emporio-chicche')) {
  customElements.define('emporio-chicche', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.pending = new WeakMap();
      this.viewportWidth = window.innerWidth;
      this.status = this.querySelector('.efx-status');
      this.version = 0;
      this.dataset.state = 'idle';
      this.preview = this.dataset.previewAllowed === 'true' && new URL(location.href).searchParams.has('emporio_chicche');
      document.addEventListener('submit', event => this.remember(event.target), { capture: true, signal });
      window.addEventListener('emporio:cart-added', event => {
        const { form, item } = event.detail || {};
        if (!form || !item || item.status) return;
        const added = Array.isArray(item.items) ? item.items[0] : item;
        const info = this.pending.get(form) || this.cartInfo(form, added);
        this.pending.delete(form);
        if (!info) return;
        if (added.image) info.src = typeof added.image === 'string' ? added.image : added.image.url || info.src;
        info.productId = added.product_id;
        queueMicrotask(() => this.playArm(info).catch(() => this.stop()));
      }, { signal });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.stop(); }, { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.stop(); }, { signal });
      window.addEventListener('pagehide', () => this.stop(), { signal });
      window.addEventListener('resize', () => {
        const width = window.innerWidth;
        if (Math.abs(width - this.viewportWidth) > 2) this.stop();
        this.viewportWidth = width;
      }, { signal });
      this.motion.addEventListener('change', () => this.stop(), { signal });
      this.setupPreview(signal);
      const gags = document.querySelector('emporio-gags');
      const mobileBattle = this.dataset.entry === 'battle' && gags?.dataset.mobile === 'false' && matchMedia('(max-width: 700px)').matches;
      if (this.dataset.entry && !this.preview && !this.motion.matches && (!gags || mobileBattle)) {
        let seen = false;
        try { seen = sessionStorage.getItem('emporio-chicca-' + this.dataset.entry + '-v1') === '1'; } catch (_) {}
        if (!seen) this.startEntry();
      }
    }
    async startEntry() {
      const kind = this.dataset.entry;
      if (await this.start(kind)) {
        try { sessionStorage.setItem('emporio-chicca-' + kind + '-v1', '1'); } catch (_) {}
      }
    }
    setupPreview(signal) {
      if (!this.preview) return;
      const controls = this.querySelector('.efx-preview');
      controls.hidden = false;
      this.querySelector('[data-fx-demo-note]').hidden = !!this.dataset.entry;
      controls.addEventListener('click', event => {
        if (event.target.closest('[data-fx-replay]')) {
          if (this.dataset.entry) this.start(this.dataset.entry);
          else {
            const marker = document.querySelector('[data-emporio-figure]');
            const form = marker?.closest('form') || document.querySelector('form[action*="/cart/add"]');
            const info = form ? this.cartInfo(form) : null;
            if (info) this.playArm(info);
          }
        }
        if (event.target.closest('[data-fx-pause]')) this.seek(Number(this.querySelector('[data-fx-frame]').value) / 100);
        if (event.target.closest('[data-fx-stop]')) this.stop();
      }, { signal });
      controls.querySelector('[data-fx-frame]').addEventListener('input', event => this.seek(Number(event.target.value) / 100), { signal });
    }
    async ready(kind) {
      window.dispatchEvent(new CustomEvent('emporio:legacy-chicca', { detail: { kind: kind } }));
      this.stop();
      const version = this.version;
      if ((this.motion.matches && kind !== 'arm') || document.hidden) return false;
      this.dataset.state = kind + '-pending';
      const stage = this.querySelector('[data-stage="' + kind + '"]');
      const images = Array.from(stage.querySelectorAll('[data-fx-image]'));
      images.forEach(img => { img.loading = 'eager'; });
      const loaded = await Promise.all(images.map(img => img.decode().then(() => true).catch(() => false)));
      if (version !== this.version || !this.isConnected || document.hidden) return false;
      if (loaded.some(value => !value)) { this.stop(); return false; }
      stage.hidden = false;
      this.stage = stage;
      this.dataset.state = kind;
      this.status.textContent = this.dataset[kind + 'Line'] || '';
      this.pauseFrame = false;
      this.pauseProgress = 0;
      return true;
    }
    async start(kind) {
      if (!['hot', 'battle'].includes(kind) || !await this.ready(kind)) return false;
      if (kind === 'hot') this.hot();
      else this.battle();
      return true;
    }
    animate(element, frames, options, master = false) {
      const animation = element.animate(frames, options);
      this.animations.push(animation);
      if (master) animation.onfinish = () => this.stop();
      return animation;
    }
    hot() {
      this.duration = 4200;
      const guest = this.stage.querySelector('.efx-guest');
      this.animate(guest, [
        { transform: 'translateX(120%) rotate(10deg)', opacity: 0, offset: 0 },
        { transform: 'translateX(-8px) rotate(-3deg)', opacity: 1, offset: .14 },
        { transform: 'translateX(0) rotate(0)', opacity: 1, offset: .21 },
        { transform: 'translateX(0) rotate(0)', opacity: 1, offset: .82 },
        { transform: 'translateX(120%) rotate(8deg)', opacity: 0, offset: 1 }
      ], { duration: this.duration, easing: 'ease-in-out', fill: 'both' }, true);
      this.animate(this.stage.querySelector('.efx-speech'), [
        { transform: 'scale(.65)', opacity: 0, offset: 0 },
        { transform: 'scale(.65)', opacity: 0, offset: .12 },
        { transform: 'scale(1.06)', opacity: 1, offset: .22 },
        { transform: 'scale(1)', opacity: 1, offset: .30 },
        { transform: 'scale(1)', opacity: 1, offset: .83 },
        { transform: 'scale(.8)', opacity: 0, offset: 1 }
      ], { duration: this.duration, fill: 'both' });
    }
    battle() {
      this.duration = 2400;
      const w = window.innerWidth, h = window.innerHeight;
      const size = Math.max(80, Math.min(124, w * .105));
      const cx = w * .5, cy = Math.max(215, h * .40);
      this.stage.style.setProperty('--top-size', size + 'px');
      const tops = this.stage.querySelectorAll('.efx-top');
      const move = (x, y, scale = 1) => 'translate(' + x + 'px,' + y + 'px) scale(' + scale + ')';
      this.animate(tops[0], [
        { transform: move(-size * 2, h * .82), opacity: 0, offset: 0 },
        { transform: move(w * .16, h * .63), opacity: 1, offset: .20 },
        { transform: move(cx - size * .90, cy - size * .5), opacity: 1, offset: .47 },
        { transform: move(cx - size * 1.05, cy - size * .35, 1.08), opacity: 1, offset: .55 },
        { transform: move(w * .13, h * .68), opacity: 1, offset: .79 },
        { transform: move(-size * 2, h * .92), opacity: 0, offset: 1 }
      ], { duration: this.duration, fill: 'both', easing: 'ease-in-out' }, true);
      this.animate(tops[1], [
        { transform: move(w + size, -size * 2), opacity: 0, offset: 0 },
        { transform: move(w * .79, h * .13), opacity: 1, offset: .20 },
        { transform: move(cx - size * .10, cy - size * .5), opacity: 1, offset: .47 },
        { transform: move(cx + size * .08, cy - size * .65, 1.08), opacity: 1, offset: .55 },
        { transform: move(w * .83, h * .12), opacity: 1, offset: .79 },
        { transform: move(w + size, -size * 2), opacity: 0, offset: 1 }
      ], { duration: this.duration, fill: 'both', easing: 'ease-in-out' });
      tops.forEach((top, i) => this.animate(top.querySelector('img'), [{ transform: 'rotate(0deg)' }, { transform: 'rotate(' + (i ? -360 : 360) + 'deg)' }], { duration: 190, iterations: Infinity }));
      const impact = this.stage.querySelector('.efx-impact');
      impact.style.left = cx + 'px'; impact.style.top = cy + 'px';
      this.animate(impact, [{ opacity: 0, transform: 'scale(.1)', offset: 0 }, { opacity: 0, transform: 'scale(.1)', offset: .43 }, { opacity: 1, transform: 'scale(1)', offset: .50 }, { opacity: .65, transform: 'scale(1.8)', offset: .60 }, { opacity: 0, transform: 'scale(2)', offset: .76 }, { opacity: 0, offset: 1 }], { duration: this.duration, fill: 'both' });
      const sparks = this.stage.querySelector('.efx-sparks');
      sparks.replaceChildren();
      for (let i = 0; i < 14; i++) {
        const spark = document.createElement('span'); spark.className = 'efx-spark'; sparks.append(spark);
        const angle = i * Math.PI / 7, distance = 85 + i % 3 * 32;
        const origin = 'translate(' + cx + 'px,' + cy + 'px) rotate(' + angle + 'rad)';
        const end = 'translate(' + (cx + Math.cos(angle) * distance) + 'px,' + (cy + Math.sin(angle) * distance) + 'px) rotate(' + angle + 'rad)';
        this.animate(spark, [{ transform: origin, opacity: 0, offset: 0 }, { transform: origin, opacity: 0, offset: .46 }, { transform: origin, opacity: 1, offset: .50 }, { transform: end, opacity: 0, offset: .84 }, { transform: end, opacity: 0, offset: 1 }], { duration: this.duration, fill: 'both', easing: 'ease-out' });
      }
    }
    cartInfo(form, item) {
      if (!(form instanceof HTMLFormElement)) return null;
      const productId = Number(item?.product_id || 0);
      const marker = form.querySelector('[data-emporio-figure]') || form.closest('[data-emporio-product]')?.querySelector('[data-emporio-figure]') || (productId ? document.querySelector('[data-emporio-figure][data-product-id="' + productId + '"]') : null);
      if (!marker || (productId && Number(marker.dataset.productId) !== productId)) return null;
      const card = form.closest('[data-emporio-product], .l4cl > li, .l4ca > li');
      const area = card || form.closest('.m6pr') || form.closest('.shopify-section');
      const images = Array.from(area?.querySelectorAll('figure img, .l4pr img') || []);
      const source = images.find(img => { const r = img.getBoundingClientRect(); return r.width > 35 && r.height > 35 && r.bottom > 80 && r.top < innerHeight; });
      const rect = (source || form.querySelector('button[type="submit"]') || form).getBoundingClientRect();
      const supplied = typeof item?.image === 'string' ? item.image : item?.image?.url;
      const src = supplied || marker?.dataset.figureImage || source?.currentSrc || source?.src || '';
      return { src, productId, x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
    }
    remember(form) {
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !new URL(form.action, location.href).pathname.endsWith('/cart/add')) return;
      const info = this.cartInfo(form);
      if (info) this.pending.set(form, info);
    }
    async playArm(info) {
      if (!info || !await this.ready('arm')) return;
      this.duration = 2500;
      const stage = this.stage, product = stage.querySelector('.efx-caught'), hand = stage.querySelector('.efx-hand');
      const fallback = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82 102"><rect x="10" y="23" width="62" height="62" rx="5" fill="#ce9b56" stroke="#382a20" stroke-width="3"/><path d="M10 40h62M41 23v62" stroke="#fff0cf" stroke-width="9"/></svg>');
      let src = info.src || fallback;
      try {
        const imageURL = new URL(src, location.href);
        if (imageURL.hostname === 'cdn.shopify.com' || imageURL.pathname.includes('/cdn/shop/')) {
          imageURL.searchParams.set('width','240');
          src = imageURL.href;
        }
      } catch (_) {}
      product.src = src;
      const version = this.version;
      try { await product.decode(); } catch (_) { product.src = fallback; }
      if (this.version !== version) return;
      const viewport = window.visualViewport;
      const w = viewport?.width || innerWidth, h = viewport?.height || innerHeight;
      const ox = viewport?.offsetLeft || 0, oy = viewport?.offsetTop || 0;
      stage.style.setProperty('--efx-width', w + 'px');
      stage.style.setProperty('--efx-height', h + 'px');
      stage.style.setProperty('--efx-left', ox + 'px');
      stage.style.setProperty('--efx-top', oy + 'px');
      const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
      const small = w <= 700;
      const start = { x: small ? w * .46 : clamp(info.x - ox, 68, w - 105), y: small ? clamp(h * .53, 100, h - 110) : clamp(info.y - oy, 100, h - 130) };
      const cart = Array.from(document.querySelectorAll('a[href$="/cart"], a[data-panel="cart"], a[href="#cart"]')).find(el => { const r = el.getBoundingClientRect(); return r.width && r.top >= 0 && r.top < 160; });
      const cr = cart?.getBoundingClientRect();
      const drawerTitle = Array.from(document.querySelectorAll('.m6pn.toggle h2')).find(el => el.getBoundingClientRect().width > 0);
      const dr = drawerTitle?.getBoundingClientRect();
      const destination = dr || cr;
      const end = { x: clamp(destination ? destination.left + destination.width / 2 - ox : w - 38, 35, w - 35), y: clamp(destination ? destination.top + destination.height / 2 - oy : 75, 40, h - 45) };
      stage.querySelector('.efx-rubber').setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      const ease = t => 1 - Math.pow(1 - t, 3);
      const paths = stage.querySelectorAll('path');
      this.drawArm = progress => {
        const reach = ease(clamp(progress / .35, 0, 1));
        const pull = ease(clamp((progress - .49) / .51, 0, 1));
        const x = progress < .49 ? w + 90 + (start.x - w - 90) * reach : start.x + (end.x - start.x) * pull;
        const y = progress < .49 ? start.y + Math.sin(reach * Math.PI) * 26 : start.y + (end.y - start.y) * pull - Math.sin(pull * Math.PI) * 55;
        const originY = start.y + 55 + (end.y - start.y - 55) * pull;
        const d = 'M ' + (w + 70) + ' ' + originY + ' C ' + (w - 30) + ' ' + (originY + 30) + ' ' + (x + 165) + ' ' + (y + 40) + ' ' + (x + 84) + ' ' + (y + 18);
        paths.forEach(path => path.setAttribute('d', d));
        hand.style.transform = 'translate(' + (x - 44) + 'px,' + (y - 58) + 'px)';
        hand.style.opacity = String(1 - clamp((progress - .88) / .12, 0, 1));
        stage.querySelector('.efx-rubber').style.opacity = hand.style.opacity;
        product.style.opacity = progress >= .32 ? String(1 - clamp((progress - .91) / .09, 0, 1)) : '0';
        product.style.transform = 'translate(' + (x - 57) + 'px,' + (y - 51) + 'px) scale(' + (1 - pull * .82) + ') rotate(' + (-12 * Math.sin(pull * Math.PI)) + 'deg)';
      };
      this.drawArm(this.pauseFrame ? this.pauseProgress : 0);
      if (this.motion.matches) {
        this.drawArm(.48);
        this.endTimer = setTimeout(() => this.stop(), 1600);
        return;
      }
      if (this.pauseFrame) return;
      const began = performance.now();
      const frame = now => {
        if (version !== this.version || this.pauseFrame) return;
        const progress = Math.min(1, (now - began) / this.duration);
        this.drawArm(progress);
        if (progress < 1) this.raf = requestAnimationFrame(frame);
        else this.stop();
      };
      this.raf = requestAnimationFrame(frame);
    }
    seek(progress) {
      if (!this.stage) return;
      this.pauseFrame = true;
      this.pauseProgress = progress;
      cancelAnimationFrame(this.raf);
      this.animations.forEach(animation => { animation.pause(); animation.currentTime = this.duration * Math.min(.99, progress); });
      if (this.drawArm && this.dataset.state === 'arm') this.drawArm(progress);
    }
    stop() {
      this.version = (this.version || 0) + 1;
      clearTimeout(this.endTimer);
      cancelAnimationFrame(this.raf);
      (this.animations || []).forEach(animation => { animation.onfinish = null; animation.cancel(); });
      this.animations = [];
      this.querySelectorAll('.efx-stage').forEach(stage => { stage.hidden = true; });
      this.stage = null;
      this.drawArm = null;
      this.dataset.state = 'idle';
      if (this.status) this.status.textContent = '';
    }
    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-seasonal-corners"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('emporio-halloween')){
  customElements.define('emporio-halloween',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      this.message=this.querySelector('[role="status"]');
      this.addEventListener('click',event=>{
        const button=event.target.closest('.emporio-halloween__pumpkin');
        if(!button)return;
        this.stop();
        button.classList.add('is-playing');
        this.message.classList.toggle('from-right',button.classList.contains('emporio-halloween__pumpkin--right'));
        this.message.hidden=false;
        this.message.textContent=this.dataset.message;
        if('speechSynthesis' in window && 'SpeechSynthesisUtterance' in window && (!this.lastSpeech || Date.now()-this.lastSpeech>2800)){
          const line=new SpeechSynthesisUtterance(this.dataset.message);
          line.lang='it-IT';line.rate=.94;line.volume=.65;
          try{window.speechSynthesis.speak(line);this.lastSpeech=Date.now();}catch(_){}
        }
        this.timer=window.setTimeout(()=>this.stop(),4500);
      },{signal:this.controller.signal});
      this.addEventListener('keydown',event=>{if(event.key==='Escape')this.stop();},{signal:this.controller.signal});
    }
    stop(){
      window.clearTimeout(this.timer);
      this.querySelectorAll('.is-playing').forEach(button=>button.classList.remove('is-playing'));
      if(this.message){this.message.hidden=true;this.message.textContent='';}
    }
    disconnectedCallback(){this.stop();this.controller?.abort();this.controller=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["emporio-stock-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('emporio-stock-grid')) {
  customElements.define('emporio-stock-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.dual !== 'true' || this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.cache = new Map();
      this.soldCards = [];
      this.soldPages = 0;
      this.soldIds = new Set();
      queueMicrotask(() => this.start());
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    async start() {
      if (!this.isConnected) return;
      this.base = new URL(location.href);
      this.size = Number(this.dataset.pageSize);
      this.total = Number(this.dataset.total);
      this.page = Math.max(1, Math.min(Math.ceil(this.total / this.size), Number(this.base.searchParams.get('page')) || 1));
      this.firstPage = this.page;
      this.status = this.querySelector('.emporio-stock-status');
      this.content = this.querySelector('[data-emporio-grid-content]');
      this.grid = this.content.querySelector('#collection');
      if (!this.grid) {
        this.dataset.ready = 'fallback';
        this.status.textContent = '';
        return;
      }
      await this.showPage(this.page, false);
    }
    async fetchGroup(group, page) {
      const key = `${group}:${page}`;
      if (!this.cache.has(key)) {
        const url = new URL(this.base);
        url.searchParams.set('section_id', this.dataset.section);
        url.searchParams.delete('sections');
        url.searchParams.set('filter.v.availability', group);
        url.searchParams.set('sort_by', 'created-descending');
        url.searchParams.set('page', String(page));
        const request = fetch(url, {signal: this.controller.signal, credentials: 'same-origin'})
          .then(response => {
            if (!response.ok) throw new Error(`Collection ${response.status}`);
            return response.text();
          })
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector('emporio-stock-grid');
            if (!source || source.dataset.filteredAvailability !== group) throw new Error('Availability filter unavailable');
            const cards = [...source.querySelectorAll('#collection > [data-emporio-product-id]')];
            if (group === '1' && cards.some(card => card.dataset.emporioAvailable !== 'true')) throw new Error('Availability changed');
            const total = Number(source.dataset.total);
            if (!Number.isFinite(total)) throw new Error('Collection count unavailable');
            return {cards, total};
          }).catch(error => {
            this.cache.delete(key);
            throw error;
          });
        this.cache.set(key, request);
      }
      return this.cache.get(key);
    }
    async soldRange(from, to) {
      while (this.soldCards.length < to) {
        const page = this.soldPages + 1;
        const result = await this.fetchGroup('0', page);
        for (const card of result.cards) {
          const id = card.dataset.emporioProductId;
          if (card.dataset.emporioAvailable === 'false' && !this.soldIds.has(id)) {
            this.soldCards.push(card);
            this.soldIds.add(id);
          }
        }
        this.soldPages = page;
        if (page * this.size >= result.total || result.cards.length === 0) break;
      }
      return this.soldCards.slice(from, to);
    }
    async getPage(page) {
      if (this.available === undefined) {
        const result = await this.fetchGroup('1', 1);
        this.available = result.total;
        if (this.available > this.total) throw new Error('Collection changed while loading');
      }
      const start = (page - 1) * this.size;
      const end = Math.min(start + this.size, this.total);
      const jobs = [];
      for (const [group, offset, count] of [['1', 0, this.available], ['0', this.available, this.total - this.available]]) {
        const from = Math.max(start - offset, 0);
        const to = Math.min(end - offset, count);
        if (group === '0') {
          if (to > from) jobs.push(this.soldRange(from, to));
          continue;
        }
        for (let cursor = from; cursor < to;) {
          const groupPage = Math.floor(cursor / this.size) + 1;
          const localStart = cursor % this.size;
          const take = Math.min(to - cursor, this.size - localStart);
          jobs.push(this.fetchGroup(group, groupPage).then(result => result.cards.slice(localStart, localStart + take)));
          cursor += take;
        }
      }
      const cards = (await Promise.all(jobs)).flat();
      if (cards.length !== end - start) throw new Error('Collection changed while loading');
      return cards;
    }
    refreshCards() {
      for (const name of ['ratings', 'semanticInput', 'schemeTooltip', 'popups', 'listScrollable']) window.dispatchEvent(new CustomEvent(name));
      if (typeof window.check_limit_event === 'function') window.check_limit_event();
      if (window.ajaxCart?.init) window.ajaxCart.init();
      if (window.quickShop?.init) window.quickShop.init();
    }
    controls() {
      this.pager?.remove();
      this.pager = document.createElement('div');
      this.pager.className = 'emporio-stock-controls';
      if (this.firstPage > 1) {
        const previous = document.createElement('a');
        const url = new URL(this.base);
        url.searchParams.set('page', String(this.firstPage - 1));
        previous.href = url.pathname + url.search;
        previous.textContent = this.dataset.previousLabel;
        this.pager.append(previous);
      }
      const info = document.createElement('p');
      info.setAttribute('aria-live', 'polite');
      info.textContent = this.dataset.countLabel.replace('__COUNT__', String(this.grid.children.length)).replace('__TOTAL__', String(this.total));
      this.pager.append(info);
      if (this.page * this.size < this.total) {
        this.more = document.createElement('button');
        this.more.type = 'button';
        this.more.textContent = this.dataset.moreLabel;
        this.more.addEventListener('click', () => this.showPage(this.page + 1, true));
        this.pager.append(this.more);
      } else this.more = null;
      this.content.append(this.pager);
    }
    async showPage(page, append) {
      if (this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      if (this.more) this.more.disabled = true;
      this.status.textContent = this.dataset.loadingLabel;
      try {
        const cards = await this.getPage(page);
        if (!this.isConnected) return;
        if (!append) {
          this.grid = this.grid.cloneNode(false);
          this.content.replaceChildren(this.grid);
        }
        const seen = new Set([...this.grid.children].map(card => card.dataset.emporioProductId));
        for (const card of cards) {
          if (!seen.has(card.dataset.emporioProductId)) {
            this.grid.append(card.cloneNode(true));
            seen.add(card.dataset.emporioProductId);
          }
        }
        this.page = page;
        this.dataset.ready = 'true';
        this.dataset.loadedPage = String(page);
        this.status.textContent = '';
        this.controls();
        if (append) {
          const url = new URL(this.base);
          url.searchParams.set('page', String(page));
          history.replaceState(history.state, '', url.pathname + url.search + url.hash);
        }
        this.refreshCards();
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.dataset.ready = append ? 'true' : 'fallback';
        this.status.textContent = this.dataset.errorLabel + ' ';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = this.dataset.retryLabel;
        retry.addEventListener('click', () => this.showPage(page, append));
        this.status.append(retry);
        if (this.more) this.more.disabled = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
